import { fetchNotificationEvents } from '../../../hooks/useNotifications';
import { MODULE_LABELS } from '../constants/notificationsConstants';
import {
  formatDateTime,
  getNotificationMessageText,
  getNotificationPriorityText,
  getNotificationRuleText,
  getNotificationStatusLabel,
  getRecipientLabels,
} from './notificationUtils';

const CSV_PAGE_SIZE = 200;

const escapeCsvValue = (value) => {
  const text = value === null || value === undefined ? '' : String(value);
  return `"${text.replace(/\r?\n/g, ' ').replace(/"/g, '""')}"`;
};

const buildTimestamp = () => new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19);

const downloadCsv = (csvContent, filename) => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

const buildCsvContent = (events) => {
  const headers = [
    'Prioridad',
    'Modulo',
    'Regla',
    'Mensaje',
    'Contrato',
    'Destinatario',
    'Estado',
    'Generada',
  ];

  const rows = events.map((event) => [
    getNotificationPriorityText(event),
    MODULE_LABELS[event.target_app_module] || event.target_app_module || '',
    getNotificationRuleText(event),
    getNotificationMessageText(event),
    event.contract_number || '',
    getRecipientLabels(event).join(', '),
    getNotificationStatusLabel(event.status),
    formatDateTime(event.generated_at || event.created_at),
  ]);

  return `\uFEFF${[headers, ...rows]
    .map((row) => row.map(escapeCsvValue).join(','))
    .join('\n')}`;
};

export const exportFilteredNotificationsToCsv = async (filters) => {
  const firstPage = await fetchNotificationEvents({
    ...filters,
    page: 1,
    per_page: CSV_PAGE_SIZE,
  });
  const totalPages = firstPage.total_pages || 1;
  const remainingPageNumbers = Array.from(
    { length: Math.max(totalPages - 1, 0) },
    (_, index) => index + 2
  );
  const remainingPages = await Promise.all(
    remainingPageNumbers.map((page) =>
      fetchNotificationEvents({
        ...filters,
        page,
        per_page: CSV_PAGE_SIZE,
      })
    )
  );
  const events = [
    ...(firstPage.results || []),
    ...remainingPages.flatMap((pageData) => pageData.results || []),
  ];

  downloadCsv(
    buildCsvContent(events),
    `notificaciones_${buildTimestamp()}.csv`
  );
};
